import React, { Component } from "react";
import classNames from "classnames";
import { PropTypes } from "prop-types";
import styles from "../Product/ProductDetails-tw-styles";
import { getCdnImage } from '../../../utils/ImageManager';
import Typography from "../../Generic/Typography";
import { getPrimaryRating } from '../../../services/bazaarvoice-api';
import Rating from "../../Generic/Rating";
import bvstyles from '../../Generic/BuyNowLite/BuyNowLite-tw-styles';
import getCdnSrcset from '../../../utils/srcSetHelper';
import i18nMessages, {
    PDPAccordionTitle, ratingsReviewsID
} from '../../../constants/messages/pt-BR';
import Head from "next/head";
import PDPCarousal from "../PDPCarousal/PDPCarousal";
import PDPAccordion from "../Accordian/components/PDPAccordian";
import PDPAccordionPanelHeader from "../Accordian/components/PDPAccordionPanelHeader";
import PDPAccordionPanel from "../Accordian/components/PDPAccordianPanel";
import PDPAccordionPanelDetails from "../Accordian/components/PDPAccordionPanelDetails";
import Image from "next/image";
import cardStyles from '../Product/card-tw-styles';
import SocialShare from "../SocialShare/SocialScrollWrapper";
import { Button } from '../../Generic/Button';
import BuyNowLiteComponent from '../../Generic/BuyNowLite';
import { productDetailsDescription } from "../../../constants/global";

class NewHeadingBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ratingData: null,
            isDesktop: true,
            isExpand: false,
            initialHeight: 0,
        };
        this.firstFeatureRef = React.createRef();
    }

    componentDidMount() {
        this.handleWindowChange();
        window.addEventListener(i18nMessages.resize, this.handleWindowChange);
        const { pageData, locale } = this.props;
        const productIdList = [];
        let productDetail = pageData;
        if (productDetail && productDetail.ratingAndReviewId) {
            productIdList.push(
                productDetail && productDetail.ratingAndReviewId
            );
            getPrimaryRating(productIdList, locale)
                .then((res) => {
                    if (res.data.Results.length > 0) {
                        this.setState({
                            ratingData: res.data.Results[0],
                        });
                    }
                })
                .catch((err) => {
                    throw new Error(err);
                });
        }
    }

    componentWillUnmount() {
        document.removeEventListener(
            i18nMessages.resize,
            this.handleWindowChange
        );
    }

    handleWindowChange = () => {
        const isDesktop = window.innerWidth > 1023;
        this.setState({
            isDesktop: isDesktop,
        });
    };

    averageOverallRatingFormat = (avgOverAllRating) => {
        if (avgOverAllRating % 1 === 0) {
            return avgOverAllRating;
        } else {
            return avgOverAllRating.toFixed(2);
        }
    };

    ratingCountFormat = (ratingcount) => {
        var count = "";
        var arr = ratingcount.toString().split("");
        for (var i = 0; i < arr.length; i++) {
            count += arr[i];
            if ((arr.length - i - 1) % 3 == 0 && i < arr.length - 1)
                count += ".";
        }
        return count;
    };

    renderCommonElement = () => {
        const { pageData, productFeatureList } = this.props;
        return (
            <>
                <div className={`${styles.productDescription} mt-10`}>
                    <Typography
                        component="div"
                        className={classNames(
                            styles.desc_review_count,
                            "leading-20 tracking-0.75 text-16 md:text-16"
                        )}
                        title={`${pageData && pageData.productName} |  ${i18nMessages.pdpTitle}`}
                        onClick={this.ratingLink}
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(pageData.shortDescription),
                        }}
                    />
                </div>
                <PDPAccordion className="mb-40 -mx-[2.5rem] lg:mx-auto">
                     <PDPAccordionPanelHeader
                        title={productDetailsDescription}
                        panelIndex={"i"}
                        isExpanded={this.state.isExpand}
                        handleClick={this.handelExpanded}
                        desktopCollapsible={true}
                        smartphoneCollapsible={true}
                        smartphoneWidth={768}
                        className={"px-25 border-themeYellow border-t-1 relative lg:px-0 py-10"}
                        collapsed={
                            <img className={"mins"} src="/static/images/MinusSymbol.svg" alt="minus icon" />
                        }
                        expanded={
                            <img className={"plus"} src="/static/images/PlusSymbol.svg" alt="plus icon" />
                        }
                    >
                        <p className="color-gradient-yellow-stack uppercase max-w-[95%] sm:text-28 md:max-w-full tracking-0.84 md:tracking-wider1x leading-40 md:leading-60 text-30 md:text-50 pl-8 font-BebasNeueBold">
                            {productDetailsDescription}
                        </p>
                    </PDPAccordionPanelHeader>
                    <PDPAccordionPanel className="w-full">
                        <PDPAccordionPanelDetails
                            isExpanded={this.state.isExpand}
                            initialHeight={this.state.initialHeight}
                        >
                            <div
                                id="pdp-accordion"
                                ref={(node) =>
                                    !this.state.isExpand
                                        ? node?.setAttribute("inert", "")
                                        : node?.removeAttribute("inert")
                                }
                                className="pb-20 px-25 md:px-0"
                            >
                                {productFeatureList.items.map((acc, inx) => (
                                    acc.iconImage && acc.iconImage.image && acc.iconImage.image.url ?
                                        <div
                                            key={inx}
                                            className="clear-both pb-14 lg:pb-8 overflow-hidden px-25 lg:py-0 flex items-end md:items-center productFeatureListIcon"
                                            tabIndex={0}
                                        >
                                            <div className="flex-grow-0 flex-shrink w-38 h-38 lg:w-30 lg:h-30 iconImageDiv" aria-hidden="true">
                                                <Image
                                                    width={38}
                                                    height={38}
                                                    alt=""
                                                    className="w-full h-auto mt-10 md:mt-0"
                                                    src={acc.iconImage?.image?.url}
                                                />
                                            </div>
                                            <Typography
                                                component="div"
                                                className={"ml-10 text-16 leading-23 tracking-0.30 text-black w-full font-medium float-left textFont"}
                                                dangerouslySetInnerHTML={{
                                                    __html: DOMPurify.sanitize(acc.title),
                                                }}
                                            />
                                        </div>
                                    :
                                        <div
                                            key={inx}
                                            className="clear-both pb-14 lg:pb-8 overflow-hidden px-50 lg:py-0 flex items-end md:items-center productFeatureListIcon"
                                            tabIndex={0}
                                        >
                                            <div className="golden-bullets">
                                                <Typography
                                                    component="div"
                                                    className={"ml-10 text-16 leading-23 tracking-0.30 text-black w-full font-medium float-left textFont"}
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(acc.title),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                ))}
{pageData?.disclaimerText && <div className={`pb-20 px-35 mb-20`}>
                    <Typography
                        component="div"
                        title={`${pageData && pageData?.disclaimerText}`}
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(pageData.disclaimerText),
                        }}
                    />
                </div>}
                                <div
                                    className="mx-auto w-full block lg:justify-center md:mt-20 pb-20 justify-center min-h-50 md:hidden float-left"
                                >
                                    <div id="buy-now-mob" >
                                        <BuyNowLiteComponent
                                            gtinId={pageData && pageData.gtin}
                                            variant={
                                                pageData &&
                                                pageData.variantsCollection &&
                                                pageData.variantsCollection.items
                                            }
                                            linkText={i18nMessages.buyNowNew}
                                            productShortName={pageData?.productShortName}
                                            className="uppercase block  hover:bg-white hover:border-1 hover:border-themeYellow px-30 py-17 text-25 leading-14 text-white text-center mx-auto tracking-1.74 my-0 w-250 cursor-pointer rounded-30 button-tertiary font-BebasNeueRegular"
                                        />
                                    </div>

                                </div>
                            </div>
                        </PDPAccordionPanelDetails>
                    </PDPAccordionPanel>
                </PDPAccordion>
                
            </>
        );
    };

    handelExpanded = () => {
        const height = document.getElementById("pdp-accordion").scrollHeight;
        const willExpand = !this.state.isExpand;
        this.setState({
            isExpand: willExpand,
            initialHeight: height <= 400 ? height + 70 : height + 40,
        }, () => {
            // Move focus to first feature point after expanding
            if (willExpand && this.firstFeatureRef.current) {
                this.firstFeatureRef.current.focus();
            }
        });
    };

    render() {
        const { pageData, imageList } = this.props;
        const { ratingData, isDesktop } = this.state;
        return (
            <>
                <Head>
                    <link
                        rel="preconnect"
                        href="https://api.bazaarvoice.com/"
                    />
                    <link
                        rel="preload"
                        href={
                            pageData?.productImage &&
                            getCdnImage(pageData.productImage.url)
                        }
                        as="image"
                    />
                </Head>
                <div className={styles.headingBannerMainParent}>
                    <div className={styles.headingBanner}>
                        <PDPCarousal imageList={imageList} />
                        <div className={styles.headingTextWrapper}>
                            <div>
                                <div
                                    id={i18nMessages.topHeaderText}
                                    className={styles.topHeadingTextWrapper}
                                >
                                    <div
                                        id={i18nMessages.topHeaderTextMain}
                                        className={styles.productTitle}
                                    >
                                        <Typography
                                            component="h1"
                                            className={classNames(
                                                styles.productTitleText, 'color-gradient-yellow-stack'
                                            )}
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(pageData.productName),
                                            }}

                                            id={i18nMessages.topHeaderTextBig}
                                        ></Typography>
                                        <Typography
                                            component="strong"
                                            className={classNames(
                                                styles.productTitleTextSmall
                                            )}
                                            id={i18nMessages.topHeaderTextSmall}
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(pageData.productName),
                                            }}
                                        />


                                    </div>
                                </div>
                            </div>
                            {this.renderCommonElement()}

                            <div
                                id="buy-now-light-desktop"
                                className="mx-auto w-full hidden lg:justify-center justify-center min-h-50 md:block float-left"
                            >

                                <div id="buyNowBtn" >
                                    <BuyNowLiteComponent
                                        gtinId={pageData && pageData.gtin}
                                        variant={
                                            pageData &&
                                            pageData.variantsCollection &&
                                            pageData.variantsCollection.items
                                        }
                                        linkText={i18nMessages.buyNowNew}
                                        productShortName={pageData?.productShortName}
                                        className="uppercase block  hover:bg-white hover:border-1 hover:border-themeYellow px-30 py-17 text-25 leading-14 text-white text-center mx-auto tracking-1.74 my-0 w-250 cursor-pointer rounded-30 button-tertiary font-BebasNeueRegular"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default NewHeadingBanner;

NewHeadingBanner.propTypes = {
    pageData: PropTypes.oneOfType([PropTypes.object]).isRequired,
    imageList: PropTypes.array.isRequired,
    product: PropTypes.oneOfType([PropTypes.object]).isRequired,
    locale: PropTypes.string.isRequired,
    i18nMessages: PropTypes.oneOfType([PropTypes.object]).isRequired,
    variant: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    country: PropTypes.string,
    productFeatureList: PropTypes.object,
};

NewHeadingBanner.defaultProps = {
    variant: [],
};
